import React from "react";
import { Card, Box, Typography, Skeleton } from "@mui/material";
import EmptyState from "../ui/EmptyState";
import BarChartIcon from "@mui/icons-material/BarChartOutlined";

/**
 * Shared frame for every chart: title, optional subtitle and trailing control,
 * plus consistent loading and empty treatments so charts never pop in at
 * different heights.
 */
export default function ChartCard({
  title,
  subtitle,
  action,
  height = 260,
  loading = false,
  isEmpty = false,
  emptyMessage = "No data for this period.",
  children,
}) {
  return (
    <Card sx={{ p: { xs: 2, sm: 2.5 }, height: "100%", display: "flex", flexDirection: "column" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: 2,
          mb: 2,
        }}
      >
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="h6">{title}</Typography>
          {subtitle && (
            <Typography variant="caption" color="text.secondary">
              {subtitle}
            </Typography>
          )}
        </Box>
        {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
      </Box>

      {/* minWidth:0 is load-bearing — without it the flex child can't shrink and
          ResponsiveContainer measures a width wider than the card. */}
      <Box sx={{ flexGrow: 1, minHeight: height, minWidth: 0, width: "100%" }}>
        {loading ? (
          <Skeleton variant="rounded" height={height} />
        ) : isEmpty ? (
          <EmptyState dense icon={BarChartIcon} title="Nothing to chart yet" description={emptyMessage} />
        ) : (
          children
        )}
      </Box>
    </Card>
  );
}
